import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ChevronDownIcon } from 'lucide-react';
import Moment from 'moment-timezone';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Badge } from 'twyne-new.ui'

import appStore from 'stores/app'

const propTypes = {
  onChange: PropTypes.func,
  color: PropTypes.string,
  outline: PropTypes.bool,
  className: PropTypes.string,
  dates: PropTypes.object
};

const todayStart = Moment.tz(appStore.timezone).startOf('day');
const todayEnd = Moment.tz(appStore.timezone).endOf('day');
const yesterdayStart = Moment.tz(appStore.timezone).startOf('day').subtract(1, 'days');
const yesterdayEnd = Moment.tz(appStore.timezone).endOf('day').subtract(1, 'days');
const lastWeekStart = Moment.tz(appStore.timezone).startOf('day').subtract(1, 'weeks');
const lastMonthStart = Moment.tz(appStore.timezone).startOf('day').subtract(1, 'months');
const currentMonthStart = Moment.tz(appStore.timezone).startOf('month').startOf('day');
const pastMonthStart = Moment.tz(appStore.timezone).startOf('month').startOf('day').subtract(1, 'months');
const endPastMonth = Moment.tz(appStore.timezone).startOf('month').subtract(1, 'months').endOf('month');

const DateRangeOptions = [
  { name: 'Today', start: todayStart, end: todayEnd },
  { name: 'Yesterday', start: yesterdayStart, end: yesterdayEnd },
  { name: 'Last 7 days', start: lastWeekStart, end: todayEnd },
  { name: 'Last 30 days', start: lastMonthStart, end: todayEnd },
  { name: 'Month to date', start: currentMonthStart, end: todayEnd },
  { name: 'Last month', start: pastMonthStart, end: endPastMonth }
];

const getRangeName = ({ startDate, endDate }) => {
  startDate = startDate ? startDate.format('MM-DD-YYYYTHH:mm:ss') : null;
  endDate = endDate ? endDate.format('MM-DD-YYYYTHH:mm:ss') : null;

  for (let opt of DateRangeOptions) {
    if ( startDate === opt.start.format('MM-DD-YYYYTHH:mm:ss') && endDate === opt.end.format('MM-DD-YYYYTHH:mm:ss') ) {
      return opt.name;
    }
  }

  return 'Select date range';
}

class DateRangeButton extends Component {
  state = {
    open: false
  }

  toggle = () => {
    this.setState({ open: !this.state.open });
  }
  
  handleClick = (start, end) => {
    if (this.props.onChange) {
      this.props.onChange({ startDate: start, endDate: end });
    }
  }

  render() {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger>
          <Badge size='lg' className={`self-center ${this.props.className}`} color={this.props.color || 'accent'} variant={this.props.variant || 'default'}>
            {getRangeName(this.props.dates ? this.props.dates : {})}
            <ChevronDownIcon size={12} />
          </Badge>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {DateRangeOptions.map((option, index) => <>
            <DropdownMenuItem
              key={index}
              onClick={() => this.handleClick(option.start, option.end)}
            >
              {option.name}
            </DropdownMenuItem>
          </>)}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
}

DateRangeButton.propTypes = propTypes;

export default DateRangeButton;
const [
  TODAY,
  YESTERDAY,
  LASTWEEK,
  LASTMONTH,
  MONTHTODATE,
  PASTMONTH,
] = DateRangeOptions

export {
  TODAY,
  YESTERDAY,
  LASTWEEK,
  LASTMONTH,
  MONTHTODATE,
  PASTMONTH
}